import './Detail_download.scss';
import * as S from '../scss/theme';
import React, { useState, useEffect } from "react";
import fnc from '../mymod/commFunction';
import fncS3 from '../mymod/commFunction3';
import fncS4 from '../mymod/commFunction4';
import Button from '@mui/material/Button';
import Combobox from '../comm/Combobox_noBMK';
import Select from 'react-select';
import HeaderTitle from "../comm/HeaderTitle";
import { useDispatch, useSelector } from 'react-redux';
import { setIsModalTest, bookCode, setBookCode } from '../reduxToolkit/redux';
import Exam2Main from '../page_exam/Exam2Main';
import BookMain from '../page_book/BookMain';


const Detail_download = ({}) => {

    // const fileFolder = process.env.REACT_APP_fileFolder;
    const s3_acaCode = fnc.getCookie('s3_acaCode');
    const fileFolder = `${process.env.REACT_APP_uploadFileFolder}/${s3_acaCode}` ;
    const version = useSelector(state => state.reduxStore.version);

    const dispatch = useDispatch();
    // const classCode = useSelector(state => state.reduxStore.classCode);
    // const lessonDate = useSelector(state => state.reduxStore.lessonDate);
    const lmsListCode = useSelector(state => state.reduxStore.lmsListCode);

    const [list, setList] = useState([]);
    const [selectedIdx, setSelectedIdx] = useState(0);
    const [isRefresh, setIsRefresh] = useState(false);
    const [selectedUnitItem, setSelectedUnitItem] = useState({});
    const [isModalTest, setIsModalTest] = useState(false);
    const [bookName, setBookName] = useState(null);
    const [bookTestKind, setBookTestKind] = useState(null);
   
    useEffect(() => {
      fncSelect_list();
    }, [isRefresh]);

    
  function fncSelect_list() {
    const acaCode = fnc.getCookie('acaCode');
    const stCode = fnc.getCookie('stCode');
    
    fnc.sendAxios('/select/lms/course/fileDownload', { acaCode, parentCode: lmsListCode }, (res) => {
      if (res && Array.isArray(res)) { 
        setList(getRecords(res));
      } else {
        console.log(res,"select/lms/course/studyTest");
      }
    });
  }

  
  function getRecords(res) {
    let records = [];
    let kind = null;
    for (let i = 0; i < res.length; i++) { 
        const sno = res[i]["sno"];     
        const fileCode= res[i]["fileCode"];
        const fileName = res[i]["fileName"];
        const kind = res[i]["kind"];
        const parentCode = res[i]["parentCode"];
        const code = res[i]["code"];
        const s3Key = res[i]["s3Key"];
        records.push({ sno, fileCode, fileName, kind, parentCode, code, s3Key });
    }
    return records;
  }

  function onClickTr() {

  }

  


//   function onClickDownload(item) { 
        
//     const rtn = window.confirm('파일을 다운로드하시겠습니까?@');
//     if(!rtn) return null;

//     const fileName = item.fileName;
//     const fileNameCode = item.fileCode;
//     let s3FilePath = fncS3.getS3PathDownLoad( `${fileFolder}/${fileNameCode}`, fileName);
    

//     if (s3FilePath) {
//       const link = document.createElement('a');
//       link.href = s3FilePath; // S3의 직접 다운로드 링크
//       link.setAttribute('download', fileName); // 다운로드할 파일 이름 설정(직업 다운로드 시 안 먹혀) blob은 웹뷰에서 안먹혀
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } else {
//       console.log('S3 파일 경로가 올바르지 않습니다.');
//     }
//  }



  function onClickDownload(item) {//250724변경 (lmstec에는 파일업로드에 있음 )

    if (typeof version === 'string' && version.toLowerCase().includes('ios')) {
        onClickDownload_ios(item);
    } else {
        onClickDownload_pc(item);//android도 이걸로
    }
  }

  async function onClickDownload_pc(item) { // 이게 사용하는 것임 lmstec 파일업로드

    const rtn = window.confirm('파일을 다운로드하시겠습니까?');
    if(!rtn) return null;
    const fileName = item.fileName;
    const fileNameCode = item.fileCode;
    const s3Key = item.s3Key;

    // let s3FilePath = fncS3.getS3PathDownLoad( `${fileFolder}/${fileNameCode}`, fileName);
    let s3FilePath = await fncS4.getS3PathDownLoad_rename( s3Key, fileName);//c20250427072508415_ccc.zip => ccc.zip
    //let s3FilePath = await fncS4.getS3PathDownLoad_rename( `${fileFolder}/${fileNameCode}`, fileName);//c20250427072508415_ccc.zip => ccc.zip

    if (s3FilePath) {
      const link = document.createElement('a');
      link.href = s3FilePath; // S3의 직접 다운로드 링크
      link.setAttribute('download', fileName); // 다운로드할 파일 이름 설정(직업 다운로드 시 안 먹혀) blob은 웹뷰에서 안먹혀
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      alert('S3 파일 경로가 올바르지 않습니다.');
    }
  }


  async function onClickDownload_ios(item) {//ios는 보안때문에 새 페이지를 거쳐서 직접 클릭으로 해야함 인코딩이 깨져
    const rtn = window.confirm('파일을 다운로드하시겠습니까?');
    if (!rtn) return;

    const fileName = item.fileName;
    const fileNameCode = item.fileCode;
    const s3Key = item.s3Key;
  
    let s3FilePath = await fncS4.getS3PathDownLoad_rename(s3Key, fileName); // 예: c20250427072508415_ccc.zip => ccc.zip

    const encodedUrl = encodeURIComponent(s3FilePath);
    const path = `https://kuebs.org/fileDownloadWebpage?s3Url=${encodedUrl}`;

    if (path) {
      // iOS WebView 내에서 실행 중이고, callWebSite 핸들러가 존재할 경우
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callWebSite) {
        window.webkit.messageHandlers.callWebSite.postMessage(path); // Safari로 URL 전달
      } else {
        // fallback: 일반 웹브라우저에서는 새 창으로 열기
        window.open(path, '_blank');
      }
    } else {
      alert('S3 파일 경로가 올바르지 않습니다.');
    }
  }

  
  async function onClickDownload_android(item) {//이건 사용 안 함
    //안드로이드에서는 버튼을 무시하고 바로 다운로드 됨 (pc버전으로 사용하도록 복잡해 보여)
    const rtn = window.confirm('파일을 다운로드하시겠습니까?6');
    if (!rtn) return;
  
    const fileName = item.fileName;
    const fileNameCode = item.fileCode;
    const s3Key = item.s3Key;
  
    let s3FilePath = await fncS4.getS3PathDownLoad_rename(s3Key, fileName, 6000); // 예: c20250427072508415_ccc.zip => ccc.zip

    const encodedUrl = encodeURIComponent(s3FilePath);
    const path = `https://kuebs.org/fileDownloadWebpage?s3Url=${encodedUrl}`;

    if (path) {

      if (window.myJSInterface && typeof window.myJSInterface.callWebSite === 'function') {
        window.myJSInterface.callWebSite(s3FilePath);
      } else {
        // fallback: 웹브라우저용
        window.open(s3FilePath, '_blank');
      }
    } else {
      alert('S3 파일 경로가 올바르지 않습니다.');
    }
  }



  
    //=================================================
    return (
      list.length>0 && (<div className="Detail_download">
        <div className="title">파일 다운로드</div>
        <div className="wrap-main">
          <section className="section-main">
            <table className="table-hong table-main">
              <thead>
                <tr>
                  <th>종류</th>
                  <th>파일명</th>
                  <th>다운로드</th>
                </tr>
              </thead>

              <tbody>
                {list &&
                  list.map((item, index) => (
                    <tr key={index} onClick={() => onClickTr(item, index)}>
                      <td>{item.kind}</td>
                      <td>{item.fileName}</td>
                      <td>
                        <Button
                          className="btnDownload"
                          onClick={() => onClickDownload(item)}
                        >
                          다운
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>


          
         
         
          </section>

          {isModalTest && (
               <section className='section-exam'>
                <div className="box_modal_test">
                  <HeaderTitle onBackClick={()=>setIsModalTest(false)} title={bookName} direction={1}/>
                    {bookTestKind === 'TEST' ? (
                    <Exam2Main selectedItem={selectedUnitItem} />
                    ) : (
                    <BookMain selectedItem={selectedUnitItem} />
                    )}     
                </div>
              </section>
            )}
          
        </div>
      </div>
      )
    );
}

export default Detail_download;